export const BellIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden
    focusable="false"
  >
    <path
      d="M10 2.5a4.6 4.6 0 0 0-4.6 4.6v2.05c0 .5-.2.98-.56 1.33l-.6.6c-.72.7-.3 1.92.7 1.92h10.12c1 0 1.42-1.22.7-1.92l-.6-.6a1.87 1.87 0 0 1-.56-1.33V7.1A4.6 4.6 0 0 0 10 2.5Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <path
      d="M12.1 15.5a2.15 2.15 0 0 1-4.2 0"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
)
